import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as notificationActions from '@/components/notification/Actions';
import { FRONTEND_ROUTES, ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';
import { historyReplace } from '@/services/History';
import * as forgotPasswordActions from '../store/actions';
import { forgotPasswordActionTypes } from '../store/constants';

export default function* (): Generator {
	yield all([
		yield takeLatest(
			forgotPasswordActionTypes.FORGOT_PASSWORD_REQUEST,
			handleForgotPasswordRequest,
		),
	]);
}

export function* handleForgotPasswordRequest(action: any) {
	try {
		const { email } = action.payload;

		const { data } = yield call(processRequest, ROUTES_API.RESET_PASSWORD_REQUEST, 'POST', {
			email,
		});
		yield put(forgotPasswordActions.forgotPasswordSuccess());
		yield call(historyReplace, FRONTEND_ROUTES.LOGIN);
		yield put(notificationActions.createNotification(data.info, null, false, 5000));
	} catch (e: any) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(forgotPasswordActions.forgotPasswordError());
	}
}
